<template>
  <div class="view-tasklists">
    <user-menu />
    <div class="wrapper page_to_up">
      <masteradmin-sidebar-menu v-if="((masterAdmin === true) && (!$store.state.switch_admin_username))" />
      <admin-sidebar-menu v-if="((admin === true) || ($store.state.switch_admin_username))" />
      <CSRSidebarMenu v-if="csr == true" />
        <div class="content-wrapper">
          <div class="container-wrapper center">

          <div>

            <div class="form_row">
              <div class="form_col_1">
                <h3 class="d-inline heading">{{ pageHeading }}</h3>
              </div>
              <div class="form_col_2">
                <div class="float-right scroll_box cursor-pointer">
                  <span class="scroll_up_down" @click="scrollToElement('down')">
                    <i class="fa fa-angle-down angle_font"></i>
                  </span>
                </div>
              </div>
            </div>
            
            <div class="heading-seperator"></div>
              <div class="float-left col-md-9 col-12 override-padding" style="font-size: 16px;">
                <div class="text-align-center" style="padding-top: 7px;">
                  {{ this.sub_tasklist_obj.tasklist.name }}
                  <i @click="editTaskListModalAction()" class="cursor-pointer fa fa-pencil-square-o" style="font-size: 15px !important;" aria-hidden="true" ></i>
                </div>

              </div>
              <div class="float-right text-right col-md-3 col-12 override-padding" style="padding-top: 5px;">
                <button
                    v-if="sub_tasklist_obj.tasks.length == 0"
                    v-on:click="HeadingClick()"
                    class="btn btn-red save-button-width btn-md input-height-15"
                    ><i class="fa fa-plus" aria-hidden="true"></i> Skill</button>
                <button
                    v-if="sub_tasklist_obj.skills.length == 0"
                    v-on:click="DirectTaskClick()"
                    class="btn btn-red save-button-width btn-md input-height-15"
                    ><i class="fa fa-plus" aria-hidden="true"></i> Task</button>
              </div>
              <div style="clear: both" ></div>
            <div class="heading-seperator" style="margin-top: 5px;"></div>
          </div>
          <div style="clear: both" class="margin-bottom-5"></div>
          <div class="col-12 override-padding">
          <div class="task-list-summary float-left col-10 override-padding" style="padding-top: 1px;">
            <span>Summary:</span> <span style="padding-left: 25px;">{{ headingsCount }} Skills</span> <span style="padding-left: 25px;">{{ tasksCount }} Tasks</span>
          </div>

          <div
            
            class="submit float-right col-2 override-padding" @click="onSubmit">
            <button type="submit" class="col-12 btn btn-red btn-md col-12 input-height-15">Save List</button>
          </div>
          <div style="clear: both" class="margin-bottom-10"></div>
          </div>

          <div class="col-12 p-0 text-right">
          </div>

          <div style="clear: both" class="margin-bottom-10"></div>
          <div
            class="subtaskadd col-12 override-padding"
            v-if="addSubtaskShow === true">
            <div class="col-lg-10 col-sm-9 col-12 float-left override-padding" style="padding-right: 5px;">
              <input
                  v-model="skill_title"
                  type="text"
                  name="skill_title"
                  id="skill_title"
                  ref="skill_title"
                  placeholder="Enter Skill Title"
                  class="col-12 input-height-25"
                  maxlength="255" />
            </div>
            <div class="col-lg-2 col-sm-3 col-12 float-right override-padding text-align-right">
              <button
                  v-on:click="addSkillAction"
                  class="btn btn-red save-button-width btn-md input-height-15"
                  ><b>Save</b></button>
              <i class="cursor-pointer fa fa-times" style="padding-left: 10px;" aria-hidden="true" @click="closeAddSubtaskInput()"></i>
            </div>
            <div style="clear: both" ></div>
          </div>

          <div class="subtask_list">
            <ul v-sortable="{onEnd: reorderSubtask, handle: '.handle1'}" class="counter_subtask-list list-group col-lg-12 override-padding margin-bottom-10">
              <li class="list-group-item input-height-25" v-for="(skill, sIndex) in sub_tasklist_obj.skills" :key="skill.sortid">
                <div class="subtask_item" >
                  <div class=" float-left" style="width: 53%;">
                    <div v-if="skill.edit" class="float-left col-12 override-padding" >
                      <input v-model="skill.name"
                          class="col-lg-10 input-height-20"
                          maxlength="255" />
                      <button
                          v-on:click="updateSubtasksAction(skill)"
                          class="btn btn-red btn-md input-height-15"
                          ><b>Save</b></button>
                    </div>
                    <div v-else class="handle1 float-left override-padding col-12 custom-checkbox" style="padding-top: 2px;">
                      <i class="fa fa-arrows padding-right-5" aria-hidden="true"></i>
                      <span class="counter_subtask-list__counter"></span>
                      {{ skill.name }} <i @click="skill.edit = true;" class="cursor-pointer fa fa-pencil-square-o" aria-hidden="true" ></i>


                      <input 
                        class="custom-control-input"
                        name="subtask_add_rep_enabled"
                        :value="skill.id" 
                        :id="skill.sortid" 
                        type="checkbox" 
                        v-model="skill.enableAddRep"
                        :disabled="skill.disabled" 
                        @click="changeSubtasksAddRep(sIndex, $event)"
                        >
                        <label :for="skill.sortid" class="custom-control-label" style="margin-top: 2px; margin-left: 30px;"></label>
                        <label >
                            Add Rep at Skill Level
                        </label>

                    </div>
                  </div>
                  <div v-if="skill.tasks.length > 0" class="float-left font-15  text-center override-padding" style="width: 14.33%">
                    Rep Goal
                  </div>
                  <div v-if="skill.tasks.length > 0" class="float-left font-15 text-center override-padding" style="width: 13.33%">
                    Rep Competency
                  </div>
                  <div class=" float-right override-padding text-align-right" style="width: 19.33%;">
                    <span
                      v-if="skill.tasks_count > 0"
                      style="color: #007BFF; padding-right: 1px; font-size: 15px;">(Tasks: {{ skill.tasks_count }})</span>
                    <button
                        
                        v-on:click="TaskClick(skill, sIndex)"
                        class="btn btn-red save-button-width btn-md input-height-15"
                        ><i class="fa fa-plus" aria-hidden="true"></i> Task</button>
                    <i class="cursor-pointer fa fa-times" v-if="sub_tasklist_obj.tasklist.status == 'DRAFT'" style="padding-left: 10px;" aria-hidden="true" @click="deleteSubTaskConfirm(sIndex)"></i>
                  </div>
                  <div style="clear: both"></div>
                </div>

                <div
                  
                  class="subtask_task_container subtask_task_container_padding"
                  :class="[(skill.tasks.length > 0) ? 'margin-bottom-5 ' : '', (skill.tasks.length === 0) ? 'backgroud-none subtask_task_container_padding2' : '']" style="padding-right: 0;"
                  >
                  <div class="subtask_task_list">
                    <ul v-sortable="{onEnd: reorderSubtaskTask, handle: '.handle4', group: { name: 'task-' + sIndex, put: createTaskGroupArray() }}" class="counter_task-list col-lg-12" :data-id="sIndex + '-null'">
                       <li class="list-group-item input-height-25" v-for="(task, taskIndex) in skill.tasks"  :key="task.sortid">
                         <div class="task_item">
                           <div class="handle4 float-left  override-padding" style="width: 51%;">
                            <i class="fa fa-arrows padding-right-5" aria-hidden="true"></i>
                            <span class="counter_task-list__counter"></span>
                            {{ task.name }}
                           </div>
                           <div class="float-left override-padding text-center" style="width: 14.33%">
                            <input 
                            :id="'rep_count_' + sIndex + '-' + taskIndex"
                            v-model="task.defaultRepCount"
                            class="  default-hours-height"
                            maxlength="5" style="width: 64%; margin-left: 15px;" placeholder="0" @blur="onBlurDefaultGoalEvent(sIndex, 'null', taskIndex)" />
                           </div>
                           <div class="float-left override-padding text-center" style="width: 14.33%">
                            <input v-model="task.defaultRepCompetency"
                            :id="'rep_competency_' + sIndex + '-' + taskIndex"
                            class="default-hours-height"
                            maxlength="5" style="width: 64%; margin-left: 15px;" placeholder="0" @blur="onBlurDefaultGoalEvent(sIndex, 'null', taskIndex)" />
                           </div>

                           <div class="float-left  override-padding text-center" style="width: 6%;">
                            &nbsp;
                           </div>
                           <div class="float-left font-15 override-padding text-align-right" style="width: 13.33%;">
                             <span v-if="task.priority > 0" style="padding-right: 40px;">
                                P{{ task.priority }}
                             </span>
                             <span v-else>&nbsp;</span>
                             <i class="cursor-pointer fa fa-times" aria-hidden="true" @click="deleteTaskConfirm(sIndex, 'null', taskIndex)"></i>
                           </div>
                         </div>
                         <div style="clear: both"></div>
                       </li>
                    </ul>
                  </div>
                </div>

              </li>
            </ul>
          </div>


          <div style="clear: both"></div>

          <div class="subtask_list mb-1" v-if="sub_tasklist_obj.tasks.length > 0">
                <div class="subtask_item" style="float: left; width: 100%;">
                  <div class="float-left  override-padding" style="width: 51%;">
                    &nbsp;
                  </div>
                  <div class="float-left override-padding text-center" style="width: 14.33%">
                    Rep Goal
                  </div>
                  <div class="float-left override-padding text-center" style="width: 14.33%">
                    Rep Competency
                  </div>

                  <div class="float-left  override-padding text-center" style="width: 6%;">
                    &nbsp;
                  </div>
                  <div class="float-left font-15 override-padding text-align-right" style="width: 13.33%;">
                    &nbsp;
                  </div>
                </div>
                <div style="clear: both"></div>
          </div>
          <div class="subtask_list" >
            <ul v-sortable="{onEnd: reorderDirectTask, handle: '.handle5'}" class="counter_subtask-list list-group col-lg-12 override-padding margin-bottom-10">
              <li class="list-group-item input-height-25" v-for="(task, dtIndex) in sub_tasklist_obj.tasks" :key="task.sortid">

                <div class="subtask_item" style="float: left; width: 100%;">
                  <div class="handle5 float-left  override-padding" style="width: 51%;">
                    <i class="fa fa-arrows padding-right-5" aria-hidden="true"></i>
                    <span class="counter_subtask-list__counter"></span>
                    {{ task.name }}
                  </div>
                  <div class="float-left override-padding text-center" style="width: 14.33%">
                    <input 
                    :id="'rep_count_' + dtIndex"
                    v-model="task.defaultRepCount"
                    class="  default-hours-height"
                    maxlength="5" style="width: 64%; margin-left: 15px;" placeholder="0" @blur="onBlurDefaultGoalEvent('null', 'null', dtIndex)" />
                  </div>
                  <div class="float-left override-padding text-center" style="width: 14.33%">
                    <input v-model="task.defaultRepCompetency"
                    :id="'rep_competency_' + dtIndex"
                    class="default-hours-height"
                    maxlength="5" style="width: 64%; margin-left: 15px;" placeholder="0" @blur="onBlurDefaultGoalEvent('null', 'null', dtIndex)" />
                  </div>

                  <div class="float-left  override-padding text-center" style="width: 6%;">
                    &nbsp;
                  </div>
                  <div class="float-left font-15 override-padding text-align-right" style="width: 13.33%;">
                    <span v-if="task.priority > 0" style="padding-right: 40px;">
                      P{{ task.priority }}
                    </span>
                    <span v-else>&nbsp;</span>
                    <i class="cursor-pointer fa fa-times" aria-hidden="true" @click="deleteTaskConfirm('null', 'null', dtIndex)"></i>
                  </div>
                </div>
                <div style="clear: both"></div>

              </li>
            </ul>
          </div>

          <div style="clear: both" class="margin-bottom-20"></div>
          <div class="task-list-summary float-left col-10 override-padding">
            <span>Summary:</span> <span style="padding-left: 25px;">{{ headingsCount }} Skills</span> <span style="padding-left: 25px;">{{ tasksCount }} Tasks</span>
          </div>
          <div style="clear: both" ></div>
          <div
            
            class="submit float-right col-2 override-padding" @click="onSubmit">
            <button type="submit" class="col-2 btn btn-red btn-md col-12 input-height-15">Save List</button>
          </div>
          <div style="clear: both" ></div>
          	
          <div style="clear: both" class="margin-bottom-10"></div>


            <div class="page_angle_down page_to_down">
              <div class="scroll_box cursor-pointer">
                <span class="scroll_up_down" @click="scrollToElement('up')">
                  <i class="fa fa-angle-up angle_font"></i>
                </span>
              </div>
            </div>

        </div>

        <EditTasklistModal :isModalVisible="isEditModalVisible" @close="isEditModalVisible = false">
          <span v-if="loading" class="pull-right text-danger">
            Loading...
          </span>
          <div slot="header" class="sub-heading"><h3>Update Skill Set</h3></div>
          <div slot="body">
            <div class="col-11 override-padding">
              <input v-model="edit_tasklist_title"
                    name="edit_tasklist_title"
                    placeholder="Enter Skill Set Title"
                    class="col-lg-11 input-height-25 input_class"
                    v-validate="'required'"
                    maxlength="255" />
              <div v-if="verrors.firstByRule('edit_tasklist_title', 'required')" class="margin-bottom-5 validate-warning-msg">Skill Set title is required</div>
              <div v-if="verrors.firstByRule('edit_tasklist_title', 'exists')" class="margin-bottom-5 validate-warning-msg">{{  verrors.first('edit_tasklist_title') }}</div>
            </div>
            <div style="clear: both;" class="margin-bottom-10"></div>
            <div class="col-11 override-padding" style="display:flex;">
              <div v-if="((masterAdmin === true) && (!$store.state.switch_admin_username) && (this.sub_tasklist_obj.tasklist.public == '1'))"
                class="search-padd" 
                id="affliate-wrapper" 
                style="height: 30px;width: 74%;">
                <multiselect v-model="edit_affiliate"
                  :options="affiliate_options"
                  track-by="value"
                  label="text"
                  placeholder="Select Affiliate"
                  :multiple="true"
                  :close-on-select="false"
                  :show-labels="false"
                  v-bind:name="'edit_affiliate[]'"
                  v-bind:id="'edit_affiliate'"
                  v-validate="'required'">
                  <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} selected</span></template>
                </multiselect>
                <div v-if="verrors.firstByRule('edit_affiliate[]', 'required')" class="margin-bottom-5 validate-warning-msg">Affiliate is required</div>
              </div>
              <button
                  v-on:click="editTaskListAction()"
                  class="btn btn-red col-lg-2 col-sm-2 col-3 input-height-25 createBtn"
                  ><b>Update</b></button>

            </div>
            <div v-if="verrors.firstByRule('edit_affiliate', 'required')" class="margin-bottom-5 validate-warning-msg">Affiliate is required</div>

          </div>
          <div slot="footer" class="col-3 override-padding">

          </div>
        </EditTasklistModal>

        <DeleteModal :isModalVisible="isModalVisible" :id="id" :parent_id="parent_id" @close="isModalVisible = false">
          <span v-if="loading" class="pull-right text-danger">
            Loading...
          </span>
          <div slot="header" class="sub-heading">{{ deleteMessage }}</div>
          <div slot="body">

          </div>
          <div slot="footer" class="col-3 override-padding">
            <button class="left col-12 btn btn-red" @click="isModalVisible = false; deleteAction()">Confirm</button>
          </div>
        </DeleteModal>

        <ValidationModal :isModalVisible="isValidationModalVisible" @close="isValidationModalVisible = false">
          <span v-if="loading" class="pull-right text-danger">
            Loading...
          </span>
          <div slot="header" class="sub-heading">{{ validationMessage }}</div>
          <div slot="body">

          </div>
          <div slot="footer" class="col-3 override-padding">

          </div>
        </ValidationModal>

      </div>
    </div>
  </div>
</template>

<script>

import Vue from 'vue/dist/vue.esm';
import UserMenu from '../shared/user_menu.vue';
import GoBack from '../shared/goback.vue';
import DeleteModal from '../shared/delete_modal_alert.vue';
import SubTaskList from '../admin/subtask_list.vue';
import axios from 'axios';
import router from '../../router/index.js';
import store from '../../store/store.js';
import ValidationModal from '../shared/validation_modal_alert.vue';
import MasteradminSidebarMenu from '../shared/masteradmin_sidebar_menu.vue';
import AdminSidebarMenu from '../shared/admin_sidebar_menu.vue';
import Sortable from 'sortablejs';
import EditTasklistModal from '../admin/create-tasklist-modal.vue';
import VeeValidate from 'vee-validate';
import Multiselect from 'vue-multiselect';
import CSRSidebarMenu from '../shared/csr_sidebar_menu.vue';

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

Vue.directive('sortable', {
  inserted: function (el, binding) {
    var sortable = new Sortable(el, binding.value || {});
  }
});

export default {
        data() {
          return {
            skill_title: '',
            sub_tasklists_data: {
              sub_tasklists_lists: [],
              tasklist: [],
            },
            isModalVisible: false,
            isEditModalVisible: false,
            subtaskIndexValue: '',
            headingIndexValue: '',
            taskIndexValue: '',
            deleteList: '',
            deleteMessage: '',
            id: '',
            parent_id: '',
            loading: false,
            isValidationModalVisible: false,
            validationMessage: '',
            masterAdmin: false,
            admin: false,
            csr: false,
            addSubtaskShow: false,
            sub_tasklist_obj: {
              skills: [],
              tasks: [],
              tasklist: [],
              remove_subtask: [],
              remove_tasks: [],
              subtask_sort_flag: false,
              subtaskheading_sort_subtaskId: [],
              headingtask_sort_headingId: [],
              modifiedTasksDefaultGoal:[],
            },
            edit_affiliate: [],
            edit_tasklist_title: '',
            affiliate_options: [],
            edit_tasklist_id: '',
            pageHeading: '',
            content: '',
            subtaskCount: 0,
            headingsCount: 0,
            tasksCount: 0,
            researcher: false,
          }
        },
        components: {
          UserMenu,
          GoBack,
          DeleteModal,
          SubTaskList,
          ValidationModal,
          MasteradminSidebarMenu,
          EditTasklistModal,
          AdminSidebarMenu,
          Multiselect,
          CSRSidebarMenu,
        },
        methods: {
          changeHeadingsAddRep: function(subTaskIndex, headingIndex, event) {
            if(event.target.checked == true) {
              this.sub_tasklist_obj.sub_tasklists_lists[subTaskIndex].headings[headingIndex].disabled = false;
              this.sub_tasklist_obj.sub_tasklists_lists[subTaskIndex].headings[headingIndex].enableAddRep = true;
              if(this.sub_tasklist_obj.sub_tasklists_lists[subTaskIndex].headings[headingIndex].update === true) {
                this.sub_tasklist_obj.sub_tasklists_lists[subTaskIndex].headings[headingIndex].modified = true;
              }
              this.sub_tasklist_obj.sub_tasklists_lists[subTaskIndex].enableAddRep = false;
              this.sub_tasklist_obj.sub_tasklists_lists[subTaskIndex].disabled = true;
              if(this.sub_tasklist_obj.sub_tasklists_lists[subTaskIndex].update === true) {
                this.sub_tasklist_obj.sub_tasklists_lists[subTaskIndex].modified = true;
              }
            }
            else {
              this.sub_tasklist_obj.sub_tasklists_lists[subTaskIndex].headings[headingIndex].disabled = false;
              this.sub_tasklist_obj.sub_tasklists_lists[subTaskIndex].headings[headingIndex].enableAddRep = false;
              if(this.sub_tasklist_obj.sub_tasklists_lists[subTaskIndex].headings[headingIndex].update === true) {
                this.sub_tasklist_obj.sub_tasklists_lists[subTaskIndex].headings[headingIndex].modified = true;
              }
              this.sub_tasklist_obj.sub_tasklists_lists[subTaskIndex].enableAddRep = false;
              this.sub_tasklist_obj.sub_tasklists_lists[subTaskIndex].disabled = false;
              if(this.sub_tasklist_obj.sub_tasklists_lists[subTaskIndex].update === true) {
                this.sub_tasklist_obj.sub_tasklists_lists[subTaskIndex].modified = true;
              }
            }
            this.$store.dispatch('subtasks', this.sub_tasklist_obj);
          },
          changeSubtasksAddRep: function(subTaskIndex, event) {
            if(event.target.checked == true) {
              this.sub_tasklist_obj.skills[subTaskIndex].enableAddRep = true;
              this.sub_tasklist_obj.skills[subTaskIndex].disabled = false;
              if(this.sub_tasklist_obj.skills[subTaskIndex].update === true) {
                this.sub_tasklist_obj.skills[subTaskIndex].modified = true;
              }
            }
            else {
              this.sub_tasklist_obj.skills[subTaskIndex].enableAddRep = false;
              this.sub_tasklist_obj.skills[subTaskIndex].disabled = false;
              if(this.sub_tasklist_obj.skills[subTaskIndex].update === true) {
                this.sub_tasklist_obj.skills[subTaskIndex].modified = true;
              }
            }
            this.$store.dispatch('subtasks', this.sub_tasklist_obj);
          },
          onBlurDefaultGoalEvent(subTaskIndex, headingIndex, taskIndex) {
            if(subTaskIndex === 'null') {
              var task_id = this.sub_tasklist_obj.tasks[taskIndex].id;
              var index = -1;
              if(this.sub_tasklist_obj.modifiedTasksDefaultGoal.length > 0) {
                index = this.sub_tasklist_obj.modifiedTasksDefaultGoal.findIndex(item => item.id === task_id);
              }
              var rep_count_id = 'rep_count_' + taskIndex;
              var rep_competency_id = 'rep_competency_' + taskIndex;
              var rep_count = document.getElementById(rep_count_id).value;
              var rep_competency = document.getElementById(rep_competency_id).value;
              if(rep_count == 0) {
                alert("Rep goal should be greater than zero.");
                return false;
              }
              else if(rep_competency == 0) {
                alert("Rep competency should be greater than zero.");
                return false;
              }
              else {
                if(index < 0) {
                  this.sub_tasklist_obj.modifiedTasksDefaultGoal.push({
                    id: task_id,
                    rep_count: rep_count,
                    rep_competency: rep_competency,
                  });
                }
                else {
                  this.sub_tasklist_obj.modifiedTasksDefaultGoal[index].rep_count = rep_count;
                  this.sub_tasklist_obj.modifiedTasksDefaultGoal[index].rep_competency = rep_competency;
                  this.$store.dispatch('subtasks', this.sub_tasklist_obj);
                }
                this.$store.dispatch('subtasks', this.sub_tasklist_obj);                
              }
            }
            else if(headingIndex === 'null') {
              var task_id = this.sub_tasklist_obj.sub_tasklists_lists[subTaskIndex].tasks[taskIndex].id;
              var index = -1;
              if(this.sub_tasklist_obj.modifiedTasksDefaultGoal.length > 0) {
                index = this.sub_tasklist_obj.modifiedTasksDefaultGoal.findIndex(item => item.id === task_id);
              }
              var rep_count_id = 'rep_count_' + subTaskIndex + '-' + taskIndex;
              var rep_competency_id = 'rep_competency_' + subTaskIndex + '-' + taskIndex;
              var rep_count = document.getElementById(rep_count_id).value;
              var rep_competency = document.getElementById(rep_competency_id).value;
              if(rep_count == 0) {
                alert("Rep goal should be greater than zero.");
                return false;
              }
              else if(rep_competency == 0) {
                alert("Rep competency should be greater than zero.");
                return false;
              }
              else {
                if(index < 0) {
                  this.sub_tasklist_obj.modifiedTasksDefaultGoal.push({
                    id: task_id,
                    rep_count: rep_count,
                    rep_competency: rep_competency,
                  });
                }
                else {
                  this.sub_tasklist_obj.modifiedTasksDefaultGoal[index].rep_count = rep_count;
                  this.sub_tasklist_obj.modifiedTasksDefaultGoal[index].rep_competency = rep_competency;
                  this.$store.dispatch('subtasks', this.sub_tasklist_obj);
                }
                this.$store.dispatch('subtasks', this.sub_tasklist_obj);
              }
            }
            else {
              var task_id = this.sub_tasklist_obj.sub_tasklists_lists[subTaskIndex].headings[headingIndex].tasks[taskIndex].id;
              var index = -1;
              if(this.sub_tasklist_obj.modifiedTasksDefaultGoal.length > 0) {
                index = this.sub_tasklist_obj.modifiedTasksDefaultGoal.findIndex(item => item.id === task_id);
              }
              var rep_count_id = 'rep_count_' + subTaskIndex + '-' + headingIndex + '-' + taskIndex;
              var rep_competency_id = 'rep_competency_' + subTaskIndex + '-' + headingIndex + '-' + taskIndex;
              var rep_count = document.getElementById(rep_count_id).value;
              var rep_competency = document.getElementById(rep_competency_id).value;
              if(rep_count == 0) {
                alert("Rep goal should be greater than zero.");
                return false;
              }
              else if(rep_competency == 0) {
                alert("Rep competency should be greater than zero.");
                return false;
              }
              else {
                if(index < 0) {
                  this.sub_tasklist_obj.modifiedTasksDefaultGoal.push({
                    id: task_id,
                    rep_count: rep_count,
                    rep_competency: rep_competency,
                  });
                }
                else {
                  this.sub_tasklist_obj.modifiedTasksDefaultGoal[index].rep_count = rep_count;
                  this.sub_tasklist_obj.modifiedTasksDefaultGoal[index].rep_competency = rep_competency;
                  this.$store.dispatch('subtasks', this.sub_tasklist_obj);
                }
                this.$store.dispatch('subtasks', this.sub_tasklist_obj);
              }
            }
          },
          calculateTotalHours(subTaskIndex, headingIndex, taskIndex) {
            if(headingIndex === 'null') {
              var total_hours = 0;
              var rep_count_id = 'rep_count_' + subTaskIndex + '-' + taskIndex;
              var rep_hours_id = 'rep_hours_' +  subTaskIndex + '-' + taskIndex;
              var total_hours_id = 'total_hours_' + subTaskIndex + '-' + taskIndex;
              var rep_count = document.getElementById(rep_count_id).value;
              if(rep_count == 0) {
                document.getElementById(rep_count_id).value = '';
              }

              var rep_hours = document.getElementById(rep_hours_id).value;
              if(rep_hours == 0) {
                document.getElementById(rep_hours_id).value = '';
              }

              this.sub_tasklist_obj.sub_tasklists_lists[subTaskIndex].tasks[taskIndex].defaultRepCount = rep_count.replace(/[^0-9]/g, '');
              this.sub_tasklist_obj.sub_tasklists_lists[subTaskIndex].tasks[taskIndex].defaultRepCompetency = rep_hours.replace(/[^0-9]/g, '');

              if((rep_count > 0) && (rep_hours > 0)) {
                total_hours = rep_count * rep_hours;
              }
              this.sub_tasklist_obj.sub_tasklists_lists[subTaskIndex].tasks[taskIndex].defaultTotalRepHours = total_hours;
            }
            else {
              var total_hours = 0;
              var rep_count_id = 'rep_count_' + subTaskIndex + '-' + headingIndex + '-' + taskIndex;
              var rep_hours_id = 'rep_hours_' + subTaskIndex + '-' + headingIndex + '-' + taskIndex;
              var total_hours_id = 'total_hours_' + subTaskIndex + '-' + headingIndex + '-' + taskIndex;
              var rep_count = document.getElementById(rep_count_id).value;

              var rep_hours = document.getElementById(rep_hours_id).value;

              this.sub_tasklist_obj.sub_tasklists_lists[subTaskIndex].headings[headingIndex].tasks[taskIndex].defaultRepCount = rep_count.replace(/[^0-9]/g, '');

              this.sub_tasklist_obj.sub_tasklists_lists[subTaskIndex].headings[headingIndex].tasks[taskIndex].defaultRepHours = rep_hours.replace(/[^0-9]/g, '');

              if((rep_count > 0) && (rep_hours > 0)) {
                total_hours = rep_count * rep_hours;
              }
              this.sub_tasklist_obj.sub_tasklists_lists[subTaskIndex].headings[headingIndex].tasks[taskIndex].defaultTotalRepHours = total_hours;
            }
            this.$store.dispatch('subtasks', this.sub_tasklist_obj);
          },
          calculateTaskListsSummary() {
            var SubtasksCount = 0;
            var HeadingsCount = 0;
            var TasksCount = 0;
            for(var i=0; i < this.sub_tasklist_obj.skills.length; i++) {
              HeadingsCount = parseInt(HeadingsCount + 1);
              for(var x=0; x < this.sub_tasklist_obj.skills[i].tasks.length; x++) {
                TasksCount = parseInt(TasksCount + 1);
              }
            }
            for(var i=0; i < this.sub_tasklist_obj.tasks.length; i++) {
              TasksCount = parseInt(TasksCount + 1);
            }
            this.subtaskCount = SubtasksCount;
            this.headingsCount = HeadingsCount;
            this.tasksCount = TasksCount;

          },
          editTaskListAction() {
            this.$validator.validateAll().then((result) => {
              if ((this.verrors.items.length === 0)) {
                if((!this.masterAdmin) || (this.$store.state.switch_admin_username) || (this.sub_tasklist_obj.tasklist.public != '1')) {
                  this.edit_affiliate = [];
                }
                axios('/checkTasklistsAssignment/' + this.$route.params.task_list_id,
                   {
                      method: 'POST',
                      data:
                      {
                        modifiedAffiliateId: this.edit_affiliate,
                      },
                   }
                 )
                .then((resp) => {
                    var taskListAssignmentFlag = resp.data;
                    if(taskListAssignmentFlag == 1) {
                      this.validationMessage = "Affiliate can't be changed because this tasklists is assigned to groups or mentee/student.";
                      this.isValidationModalVisible = true;
                    }
                    else {
                      axios('/tasklist/' + this.$route.params.task_list_id,
                         {
                           method: 'PATCH',
                           data:
                            {
                              name: this.edit_tasklist_title,
                              affiliate_selected: this.edit_affiliate,
                            },
                         }
                       )
                      .then((resp) => {
                          this.edit_tasklist_title = '';
                          this.edit_affiliate = '';
                          this.edit_tasklist_id = '';
                          this.isEditModalVisible = false;
                          this.loadSubTaskListsAction(this.$route.params.task_list_id);
                       })
                      .catch(error => {
                        if(error.response.data.code == '404') {
                          router.push("/view-tasklist");
                        }
                        const fieldErrors =  [];
                        // var errMsgObj = error.response.data.message;
                        var errMsgObj = JSON.parse(error.response.data.message);
                        Object.keys(errMsgObj).map(key => {
                          var newFieldErr = {field:key, msg:errMsgObj[key], rule:'exists'};
                          fieldErrors.push(newFieldErr);
                        });
                        this.$validator.errors.add(fieldErrors);

                      });

                    }
                 })
                .catch(error => {

                });

                return false;



              }
            })
            .catch(() => {

            });
          },
          editTaskListModalAction: function() {
            this.edit_tasklist_title = this.sub_tasklist_obj.tasklist.name;
            this.edit_affiliate = this.sub_tasklist_obj.tasklist.affiliate;
            this.edit_tasklist_id = this.sub_tasklist_obj.tasklist.id;
            this.isEditModalVisible = true;
          },
          closeAddSubtaskInput: function() {
            this.addSubtaskShow = false;
          },
          closeAddHeadingInput: function(subTaskIndex) {
            this.sub_tasklist_obj.sub_tasklists_lists[subTaskIndex].addHeadingShow = false;
            this.sub_tasklist_obj.sub_tasklists_lists[subTaskIndex].addHeadingButtonShow = true;
            if(this.sub_tasklist_obj.sub_tasklists_lists[subTaskIndex].headings.length === 0) {
              this.sub_tasklist_obj.sub_tasklists_lists[subTaskIndex].addTaskButtonShow = true;
            }
            this.$store.dispatch('subtasks', this.sub_tasklist_obj);
          },
          
          updateDefaultGoalAction: function() {
            if(this.sub_tasklist_obj.modifiedTasksDefaultGoal.length > 0) {
              for(var k=0; k<this.sub_tasklist_obj.modifiedTasksDefaultGoal.length; k++) {
                var task_id = this.sub_tasklist_obj.modifiedTasksDefaultGoal[k].id;
                var rep_count = this.sub_tasklist_obj.modifiedTasksDefaultGoal[k].rep_count;
                var rep_competency = this.sub_tasklist_obj.modifiedTasksDefaultGoal[k].rep_competency;

                for(var i=0; i < this.sub_tasklist_obj.sub_tasklists_lists.length; i++) {
                  for(var x=0; x < this.sub_tasklist_obj.sub_tasklists_lists[i].headings.length; x++) {
                    for(var c=0; c < this.sub_tasklist_obj.sub_tasklists_lists[i].headings[x].tasks.length; c++) {
                      if(task_id == this.sub_tasklist_obj.sub_tasklists_lists[i].headings[x].tasks[c].id) {
                        this.sub_tasklist_obj.sub_tasklists_lists[i].headings[x].tasks[c].defaultRepCount = rep_count;
                        this.sub_tasklist_obj.sub_tasklists_lists[i].headings[x].tasks[c].defaultRepCompetency = rep_competency;
                      }  
                    }
                  }
                  for(var a=0; a < this.sub_tasklist_obj.sub_tasklists_lists[i].tasks.length; a++) {
                    if(task_id == this.sub_tasklist_obj.sub_tasklists_lists[i].tasks[a].id) {
                      this.sub_tasklist_obj.sub_tasklists_lists[i].tasks[a].defaultRepCount = rep_count;
                      this.sub_tasklist_obj.sub_tasklists_lists[i].tasks[a].defaultRepCompetency = rep_competency;
                    }  
                  }
                }
              }
            }
          }, 
          doValidate: function () {
            var flag = 0;
            for(var i=0; i < this.sub_tasklist_obj.skills.length; i++) {
              for(var x=0; x < this.sub_tasklist_obj.skills[i].tasks.length; x++) {
                var rep_count = this.sub_tasklist_obj.skills[i].tasks[x].defaultRepCount;
                var rep_competency = this.sub_tasklist_obj.skills[i].tasks[x].defaultRepCompetency;
                var taskName = this.sub_tasklist_obj.skills[i].tasks[x].name;
                if(rep_count == 0) {
                  alert("Rep goal should be greater than zero for the task - " + taskName);
                  flag = 1;
                  return flag;
                }
                if(rep_competency == 0) {
                  alert("Rep competency should be greater than zero for the task - " + taskName);
                  flag = 1;
                  return flag;
                }
              }
            }
            for(var i=0; i < this.sub_tasklist_obj.tasks.length; i++) {
              var rep_count = this.sub_tasklist_obj.tasks[i].defaultRepCount;
              var rep_competency = this.sub_tasklist_obj.tasks[i].defaultRepCompetency;
              var taskName = this.sub_tasklist_obj.tasks[i].name;
              if(rep_count == 0) {
                alert("Rep goal should be greater than zero for the task - " + taskName);
                flag = 1;
                return flag;
              }
              if(rep_competency == 0) {
                alert("Rep competency should be greater than zero for the task - " + taskName);
                flag = 1;
                return flag;
              }
            }
            return flag;
          },
          onSubmit () {
            this.updateDefaultGoalAction();
            var flag = this.doValidate();
            if(flag == 0) {
            
              setTimeout(() => {
              this.sub_tasklist_obj.subtaskupdate = false;
              axios('/sub-tasklists',
                {
                  method: 'POST',
                  data: {
                      "sub_tasklist_obj": this.sub_tasklist_obj,
                  },
                })
              .then((resp) => {
                  this.$store.dispatch('subtasks', '');
                  this.$store.dispatch('tasklist_title', '');
                  if((this.$store.state.page_url) && 
                      ((this.$store.state.page_url.indexOf('account-lookup') > -1) 
                      || (this.$store.state.page_url.indexOf('account-lookup-detail') > -1) 
                      || (this.$store.state.page_url.indexOf('enterprise-lookup') > -1) 
                      || (this.$store.state.page_url.indexOf('enterprise-lookup-detail') > -1))
                    ) {
                    router.push(this.$store.state.page_url);
                  }
                  else {
                    router.push("/view-tasklist");
                  }

              })
              .catch(error => {

              });
              }, 1000);
            }
            else {
              //alert("Both section and sub-section checked for Add Rep.  Please remove one of these.");
              //return false;
            }
          },
          addSkillAction: function() {
            if(this.skill_title === '') {
              this.validationMessage = 'Please enter Skill title';
              this.isValidationModalVisible = true;
              return false;
            }
            this.sub_tasklist_obj.subtaskupdate = true;
            var sub_tasklists_lists_len = this.sub_tasklist_obj.skills.length + 1;
            this.sub_tasklist_obj.skills.push({
              id: '',
              name: this.skill_title,
              edit: false,
              update: false,
              modified: false,
              sortid: 'skill-' + sub_tasklists_lists_len,
              tasks: [],
              tasks_count: 0,
              enableAddRep: false,
              disabled: false,
            });
            this.sub_tasklists = '';
            this.sub_tasklist_obj.subtask_sort_flag = true;
            this.calculateTaskListsSummary();
            this.$store.dispatch('subtasks', this.sub_tasklist_obj);
            this.addSubtaskShow = false;
          },
          updateSubtasksAction: function(sub_tasklist) {
            if(sub_tasklist.name === '') {
              this.validationMessage = 'Please enter Sub-task title';
              this.isValidationModalVisible = true;
              return false;
            }
            this.sub_tasklist_obj.subtaskupdate = true;
            if(sub_tasklist.update === true) {
              sub_tasklist.modified = true;
            }
            sub_tasklist.edit = false;
            this.$store.dispatch('subtasks', this.sub_tasklist_obj);
          },
          addHeadingsAction: function(sub_tasklist, subTaskIndex) {
            if(sub_tasklist.headingTitle === '') {
              this.validationMessage = 'Please enter header';
              this.isValidationModalVisible = true;
              return false;
            }
            this.sub_tasklist_obj.subtaskupdate = true;
            var subtask_sort_id = this.sub_tasklist_obj.sub_tasklists_lists[subTaskIndex].sortid;
            var heading_len = this.sub_tasklist_obj.sub_tasklists_lists[subTaskIndex].headings.length + 1;
            this.sub_tasklist_obj.sub_tasklists_lists[subTaskIndex].headings.push({
              id: '',
              name: sub_tasklist.headingTitle,
              edit: false,
              update: false,
              modified: false,
              sortid: subtask_sort_id + '-heading-' + heading_len,
              tasks: [],
              enableAddRep: false,
              disabled: false,
            });
            sub_tasklist.headingTitle = '';
            sub_tasklist.addHeadingButtonShow = true;
            sub_tasklist.addHeadingShow = false;
            this.sub_tasklist_obj.subtask_sort_flag = true;
            this.calculateTaskListsSummary();
            this.$store.dispatch('subtasks', this.sub_tasklist_obj);
          },
          updateHeadingsAction: function(heading) {
            if(heading.name === '') {
              this.validationMessage = 'Please enter header';
              this.isValidationModalVisible = true;
              return false;
            }
            this.sub_tasklist_obj.subtaskupdate = true;
            if(heading.update === true) {
              heading.modified = true;
            }
            heading.edit = false;
            this.$store.dispatch('subtasks', this.sub_tasklist_obj);
          },
          choose_tasks_redirect: function (subtaskIndex, headingIndex) {
            this.sub_tasklist_obj.subtaskupdate = false;
            this.$store.dispatch('subtasks', this.sub_tasklist_obj);
            router.push("/choose-tasks/" + subtaskIndex + "/" + this.$route.params.task_list_id + "/" + headingIndex);
          },
          HeadingClick: function() {
            this.addSubtaskShow = true;
          },
          DirectTaskClick: function() {
            this.$store.dispatch('subtasks', this.sub_tasklist_obj);
            router.push("/choose-tasks/null/" + this.$route.params.task_list_id + "/null");
          },
          TaskClick: function(sub_tasklist, subtaskIndex) {
            sub_tasklist.addTaskButtonShow = true;
            this.sub_tasklist_obj.subtaskupdate = false;
            this.$store.dispatch('subtasks', this.sub_tasklist_obj);
            router.push("/choose-tasks/" + subtaskIndex + "/" + this.$route.params.task_list_id + "/null");
          },
          reorderDirectTask ({oldIndex, newIndex}) {
            this.sub_tasklist_obj.subtaskupdate = true;
            const movedItem = this.sub_tasklist_obj.tasks.splice(oldIndex, 1)[0];
            this.sub_tasklist_obj.tasks.splice(newIndex, 0, movedItem);
            this.sub_tasklist_obj.subtask_sort_flag = true;
            setTimeout(() => {
              var j=1;
              for(var i=0; i < this.sub_tasklist_obj.tasks.length; i++) {
                this.sub_tasklist_obj.tasks[i].sortid = 'dtask-' + j;
                this.sub_tasklist_obj.tasks[i].modified = true;
                j++;
              }
              this.$store.dispatch('subtasks', this.sub_tasklist_obj);
            }, 1000);
            this.calculateTaskListsSummary();
            this.$store.dispatch('subtasks', this.sub_tasklist_obj);
          },

          reorderSubtask ({oldIndex, newIndex}) {
            this.sub_tasklist_obj.subtaskupdate = true;
            const movedItem = this.sub_tasklist_obj.skills.splice(oldIndex, 1)[0];
            this.sub_tasklist_obj.skills.splice(newIndex, 0, movedItem);
            this.sub_tasklist_obj.subtask_sort_flag = true;
            setTimeout(() => {
              var j=1;
              for(var i=0; i < this.sub_tasklist_obj.skills.length; i++) {
                this.sub_tasklist_obj.skills[i].sortid = 'heading-' + j;
                var y=1;
                for(var x=0; x < this.sub_tasklist_obj.skills[i].tasks.length; x++) {
                  this.sub_tasklist_obj.skills[i].tasks[x].sortid = 'heading-' + j + '-task-' + y;
                  y++;
                }
                j++;
              }
              this.$store.dispatch('subtasks', this.sub_tasklist_obj);
            }, 1000);
            this.calculateTaskListsSummary();
            this.$store.dispatch('subtasks', this.sub_tasklist_obj);
          },
          reorderSubtaskHeading (event) {
            this.sub_tasklist_obj.subtaskupdate = true;
            var from_index = event.from.attributes[1].value;
            var to_index = event.to.attributes[1].value;
            if(from_index === to_index) {
              var parent_index = event.from.attributes[1].value;
              const movedItem = this.sub_tasklist_obj.sub_tasklists_lists[parent_index].headings.splice(event.oldIndex, 1)[0];
              this.sub_tasklist_obj.sub_tasklists_lists[parent_index].headings.splice(event.newIndex, 0, movedItem);
              this.sub_tasklist_obj.subtaskheading_sort_subtaskId.push(this.sub_tasklist_obj.sub_tasklists_lists[parent_index].id);
              setTimeout(() => {
                var parent_sortid = this.sub_tasklist_obj.sub_tasklists_lists[from_index].sortid;
                var j=1;
                for(var i=0; i < this.sub_tasklist_obj.sub_tasklists_lists[from_index].headings.length; i++) {
                  this.sub_tasklist_obj.sub_tasklists_lists[from_index].headings[i].sortid = parent_sortid + '-heading-' + j;
                  var d=1;
                  for(var c=0; c < this.sub_tasklist_obj.sub_tasklists_lists[from_index].headings[i].tasks.length; c++) {
                    this.sub_tasklist_obj.sub_tasklists_lists[from_index].headings[i].tasks[c].sortid = parent_sortid + '-heading-' + j + '-task-' + d;
                    d++;
                  }
                  j++;
                }
                this.$store.dispatch('subtasks', this.sub_tasklist_obj);
              }, 1000);
              this.calculateTaskListsSummary();
              this.$store.dispatch('subtasks', this.sub_tasklist_obj);
            }
            else {
              if((this.sub_tasklist_obj.sub_tasklists_lists[to_index].enableAddRep == true) && (this.sub_tasklist_obj.sub_tasklists_lists[from_index].headings[event.oldIndex].enableAddRep == true)) {
                alert("Both section and sub-section checked for Add Rep. Please remove one of these.");
              } 
              else if((this.sub_tasklist_obj.sub_tasklists_lists[to_index].enableAddRep == true) && (this.sub_tasklist_obj.sub_tasklists_lists[from_index].headings[event.oldIndex].enableAddRep == false)) {
                this.sub_tasklist_obj.sub_tasklists_lists[from_index].headings[event.oldIndex].enableAddRep = false;
                this.sub_tasklist_obj.sub_tasklists_lists[from_index].headings[event.oldIndex].disabled = true;
              }
              else if((this.sub_tasklist_obj.sub_tasklists_lists[to_index].enableAddRep == false) && (this.sub_tasklist_obj.sub_tasklists_lists[from_index].headings[event.oldIndex].enableAddRep == false)) {
                this.sub_tasklist_obj.sub_tasklists_lists[from_index].headings[event.oldIndex].enableAddRep = false;
                this.sub_tasklist_obj.sub_tasklists_lists[from_index].headings[event.oldIndex].disabled = false;
              }
              else {
                if(this.sub_tasklist_obj.sub_tasklists_lists[from_index].headings[event.oldIndex].enableAddRep == true) {
                  this.sub_tasklist_obj.sub_tasklists_lists[to_index].enableAddRep = false;
                  this.sub_tasklist_obj.sub_tasklists_lists[to_index].disabled = false;
                }
              }

              if (this.sub_tasklist_obj.sub_tasklists_lists[from_index].headings[event.oldIndex].update == true) {
                this.sub_tasklist_obj.remove_headings.push({
                  heading_id: this.sub_tasklist_obj.sub_tasklists_lists[from_index].headings[event.oldIndex].id,
                });
              }
              const movedItem = this.sub_tasklist_obj.sub_tasklists_lists[from_index].headings.splice(event.oldIndex, 1)[0];
              var movedFromTaskCount = movedItem.tasks.length;
              if(movedFromTaskCount > 0) {
                this.sub_tasklist_obj.sub_tasklists_lists[from_index].tasks_count = (parseInt(this.sub_tasklist_obj.sub_tasklists_lists[from_index].tasks_count) - parseInt(movedFromTaskCount));
              }
              if(movedItem.update === true) {
                movedItem.id = '';
                movedItem.update = false;
                movedItem.modified = false;
              }
              this.sub_tasklist_obj.subtaskheading_sort_subtaskId.push(this.sub_tasklist_obj.sub_tasklists_lists[from_index].id);
              this.sub_tasklist_obj.subtaskheading_sort_subtaskId.push(this.sub_tasklist_obj.sub_tasklists_lists[to_index].id);
              this.sub_tasklist_obj.sub_tasklists_lists[to_index].headings.splice(event.newIndex, 0, movedItem);
              var movedToTaskCount = this.sub_tasklist_obj.sub_tasklists_lists[to_index].headings[event.newIndex].tasks.length;
              if(movedToTaskCount > 0) {
                this.sub_tasklist_obj.sub_tasklists_lists[to_index].tasks_count = (parseInt(this.sub_tasklist_obj.sub_tasklists_lists[to_index].tasks_count) + parseInt(movedToTaskCount));
              }
              if(this.sub_tasklist_obj.sub_tasklists_lists[from_index].headings.length == 0) {
                this.sub_tasklist_obj.sub_tasklists_lists[from_index].addHeadingButtonShow = true;
                this.sub_tasklist_obj.sub_tasklists_lists[from_index].addTaskButtonShow = true;
              }
              if(this.sub_tasklist_obj.sub_tasklists_lists[to_index].headings.length > 0) {
                this.sub_tasklist_obj.sub_tasklists_lists[to_index].addHeadingButtonShow = true;
                this.sub_tasklist_obj.sub_tasklists_lists[to_index].addTaskButtonShow = false;
              }
              setTimeout(() => {
                var parent_sortid = this.sub_tasklist_obj.sub_tasklists_lists[to_index].sortid;
                var j=1;
                for(var i=0; i < this.sub_tasklist_obj.sub_tasklists_lists[to_index].headings.length; i++) {
                  this.sub_tasklist_obj.sub_tasklists_lists[to_index].headings[i].sortid = parent_sortid + '-heading-' + j;
                  var d=1;
                  for(var c=0; c < this.sub_tasklist_obj.sub_tasklists_lists[to_index].headings[i].tasks.length; c++) {
                    this.sub_tasklist_obj.sub_tasklists_lists[to_index].headings[i].tasks[c].sortid = parent_sortid + '-heading-' + j + '-task-' + d;
                    if(event.newIndex == i) {
                      this.sub_tasklist_obj.sub_tasklists_lists[to_index].headings[i].tasks[c].update = false;
                      this.sub_tasklist_obj.sub_tasklists_lists[to_index].headings[i].tasks[c].modified = false;
                    }
                    d++;
                  }
                  j++;
                }
                var parent_sortid = this.sub_tasklist_obj.sub_tasklists_lists[from_index].sortid;
                var j=1;
                for(var i=0; i < this.sub_tasklist_obj.sub_tasklists_lists[from_index].headings.length; i++) {
                  this.sub_tasklist_obj.sub_tasklists_lists[from_index].headings[i].sortid = parent_sortid + '-heading-' + j;
                  var d=1;
                  for(var c=0; c < this.sub_tasklist_obj.sub_tasklists_lists[from_index].headings[i].tasks.length; c++) {
                    this.sub_tasklist_obj.sub_tasklists_lists[from_index].headings[i].tasks[c].sortid = parent_sortid + '-heading-' + j + '-task-' + d;
                    d++;
                  }
                  j++;
                }
                this.$store.dispatch('subtasks', this.sub_tasklist_obj);
              }, 1000);
            }
            var flag = 0;
            for(var i=0; i < this.sub_tasklist_obj.sub_tasklists_lists[from_index].headings.length; i++) {
              if(this.sub_tasklist_obj.sub_tasklists_lists[from_index].headings[i].enableAddRep == true) {
                flag = 1;
              }
            }
            if(flag == 1) {
              this.sub_tasklist_obj.sub_tasklists_lists[from_index].enableAddRep = false;
              this.sub_tasklist_obj.sub_tasklists_lists[from_index].disabled = true;
            }
            else {
              this.sub_tasklist_obj.sub_tasklists_lists[from_index].disabled = false;
            }

            this.calculateTaskListsSummary();
            this.$store.dispatch('subtasks', this.sub_tasklist_obj);
          },
          reorderSubtaskTask (event) {
            this.sub_tasklist_obj.subtaskupdate = true;
            var from_index = event.from.attributes[1].value;
            var from_index_array = from_index.split("-");
            var from_subtask_index = from_index_array[0];
            var from_heading_index = from_index_array[1];
            var to_index = event.to.attributes[1].value;
            var to_index_array = to_index.split("-");
            var to_subtask_index = to_index_array[0];
            var to_heading_index = to_index_array[1];
            if(from_index === to_index) {
              const movedItem = this.sub_tasklist_obj.skills[from_subtask_index].tasks.splice(event.oldIndex, 1)[0];
              this.sub_tasklist_obj.skills[from_subtask_index].tasks.splice(event.newIndex, 0, movedItem);
              this.$store.dispatch('subtasks', this.sub_tasklist_obj);
            }
            else {
              this.sub_tasklist_obj.skills[from_subtask_index].tasks_count = (parseInt(this.sub_tasklist_obj.skills[from_subtask_index].tasks_count) - parseInt(1));
              this.sub_tasklist_obj.skills[to_subtask_index].tasks_count = (parseInt(this.sub_tasklist_obj.skills[to_subtask_index].tasks_count) + parseInt(1));
              if((from_subtask_index != 'null') && (from_subtask_index != 'null')) {
                if (this.sub_tasklist_obj.skills[from_subtask_index].tasks[event.oldIndex].update == true) {
                  this.sub_tasklist_obj.remove_tasks.push({
                    heading_id: this.sub_tasklist_obj.skills[from_subtask_index].id,
                    task_id: this.sub_tasklist_obj.skills[from_subtask_index].tasks[event.oldIndex].id,
                  });
                }
                const movedItem = this.sub_tasklist_obj.skills[from_subtask_index].tasks.splice(event.oldIndex, 1)[0];
                movedItem.update = false;
                movedItem.modified = false;
                this.sub_tasklist_obj.skills[to_subtask_index].tasks.splice(event.newIndex, 0, movedItem);
                //this.sub_tasklist_obj.headingtask_sort_headingId.push(this.sub_tasklist_obj.sub_tasklists_lists[from_subtask_index].headings[from_heading_index].id);
                //this.sub_tasklist_obj.headingtask_sort_headingId.push(this.sub_tasklist_obj.sub_tasklists_lists[to_subtask_index].headings[to_heading_index].id);
                this.$store.dispatch('subtasks', this.sub_tasklist_obj);
                setTimeout(() => {
                  var from_parent_sortid = this.sub_tasklist_obj.skills[from_subtask_index].sortid;
                  var j=1;
                  for(var i=0; i < this.sub_tasklist_obj.skills[from_subtask_index].tasks.length; i++) {
                    this.sub_tasklist_obj.skills[from_subtask_index].tasks[i].sortid = from_parent_sortid + '-task-' + j;
                    j++;
                  }
                  var to_parent_sortid = this.sub_tasklist_obj.skills[to_subtask_index].sortid;
                  var j=1;
                  for(var i=0; i < this.sub_tasklist_obj.skills[to_subtask_index].tasks.length; i++) {
                    this.sub_tasklist_obj.skills[to_subtask_index].tasks[i].sortid = to_parent_sortid + '-task-' + j;
                    j++;
                  }
                  this.$store.dispatch('subtasks', this.sub_tasklist_obj);
                }, 1000);
              }
            }
            this.calculateTaskListsSummary();
          },
          createHeaderGroupArray: function() {
            var group_list = [];
            for(var i=0; i < this.sub_tasklist_obj.sub_tasklists_lists.length; i++) {
              if((this.sub_tasklist_obj.sub_tasklists_lists[i].headings.length > 0) && (this.sub_tasklist_obj.sub_tasklists_lists[i].tasks.length == 0)) {
                group_list.push('subtask-' + i);
              }
            }
            return group_list;
          },
          createTaskGroupArray: function() {
            var group_list = [];
            for(var i=0; i < this.$store.state.sub_tasks.skills.length; i++) {
                group_list.push('task-' + i);
            }
            return group_list;
          },
          deleteSubTaskConfirm: function(subTaskIndex) {
            this.deleteMessage = 'Are you sure you want to delete? This will delete the skill and the related tasks.';
            this.subtaskIndexValue = subTaskIndex;
            this.deleteList = 'SubTask';
            this.isModalVisible = true;
          },
          deleteHeadingConfirm: function(subTaskIndex, headingIndex) {
            this.deleteMessage = 'Are you sure you want to delete? This will delete the header and the related tasks.';
            this.subtaskIndexValue = subTaskIndex;
            this.headingIndexValue = headingIndex;
            this.deleteList = 'Heading';
            this.isModalVisible = true;
          },
          deleteTaskConfirm: function(subTaskIndex, headingIndex, taskIndex) {
            this.subtaskIndexValue = subTaskIndex;
            this.headingIndexValue = headingIndex;
            this.taskIndexValue = taskIndex;
            if(this.subtaskIndexValue === 'null') {
              var remove_data = this.sub_tasklist_obj.tasks[this.taskIndexValue];
            }
            else if(this.headingIndexValue === 'null') {
              var remove_data = this.sub_tasklist_obj.skills[this.subtaskIndexValue].tasks[this.taskIndexValue];
            }
            else {
              var remove_data = this.sub_tasklist_obj.sub_tasklists_lists[this.subtaskIndexValue].headings[this.headingIndexValue].tasks[this.taskIndexValue];
            }
            this.deleteMessage = 'Are you sure you want to delete the task?';
            this.deleteList = 'Task';
            this.isModalVisible = true;
          },

          deleteAction: function() {
            this.sub_tasklist_obj.subtaskupdate = true;
            if(this.deleteList == 'SubTask') {
              var remove_data = this.sub_tasklist_obj.skills[this.subtaskIndexValue];
              if(remove_data.update == true) {
                this.sub_tasklist_obj.remove_subtask.push({
                  subtask_id: remove_data.id,
                });
                this.sub_tasklist_obj.skills.splice(this.subtaskIndexValue, 1);
              }
              else {
                this.sub_tasklist_obj.skills.splice(this.subtaskIndexValue, 1);
              }
              setTimeout(() => {
                var j=1;
                for(var i=0; i < this.sub_tasklist_obj.skills.length; i++) {
                  this.sub_tasklist_obj.skills[i].sortid = 'heading-' + j;
                  var y=1;
                  for(var x=0; x < this.sub_tasklist_obj.skills[i].tasks.length; x++) {
                    this.sub_tasklist_obj.sub_tasklists_lists[i].tasks[x].sortid = 'heading-' + j + '-heading-' + y;
                    y++;
                  }
                  /*var b=1;
                  for(var a=0; a < this.sub_tasklist_obj.sub_tasklists_lists[i].tasks.length; a++) {
                    this.sub_tasklist_obj.sub_tasklists_lists[i].tasks[a].sortid = 'subtask-' + j + '-task-' + b;
                    b++;
                  }*/
                  j++;
                }
                this.$store.dispatch('subtasks', this.sub_tasklist_obj);
              }, 1000);
              this.calculateTaskListsSummary();
              this.$store.dispatch('subtasks', this.sub_tasklist_obj);
            }
            else if(this.deleteList == 'Task') {
              if(this.subtaskIndexValue === 'null') {
                var remove_data = this.sub_tasklist_obj.tasks[this.taskIndexValue];
                if(remove_data.update == true) {
                  this.sub_tasklist_obj.remove_tasks.push({
                    heading_id: remove_data.headingId,
                    task_id: remove_data.id,
                  });
                  this.sub_tasklist_obj.tasks.splice(this.taskIndexValue, 1);
                }
                else {
                  this.sub_tasklist_obj.tasks.splice(this.taskIndexValue, 1);
                }
                setTimeout(() => {
                  var j=1;
                  for(var i=0; i < this.sub_tasklist_obj.tasks.length; i++) {
                    this.sub_tasklist_obj.tasks[i].sortid = 'dtask-' + j;
                    j++;
                  }
                  this.calculateTaskListsSummary();
                  this.$store.dispatch('subtasks', this.sub_tasklist_obj);
                }, 1000);
              }
              else if(this.headingIndexValue === 'null') {
                this.sub_tasklist_obj.skills[this.subtaskIndexValue].tasks_count = (parseInt(this.sub_tasklist_obj.skills[this.subtaskIndexValue].tasks_count) - parseInt(1));
                var remove_data = this.sub_tasklist_obj.skills[this.subtaskIndexValue].tasks[this.taskIndexValue];
                if(remove_data.update == true) {
                  this.sub_tasklist_obj.remove_tasks.push({
                    heading_id: this.sub_tasklist_obj.skills[this.subtaskIndexValue].id,
                    task_id: remove_data.id,
                  });
                  this.sub_tasklist_obj.skills[this.subtaskIndexValue].tasks.splice(this.taskIndexValue, 1);
                }
                else {
                  this.sub_tasklist_obj.skills[this.subtaskIndexValue].tasks.splice(this.taskIndexValue, 1);
                }
                if(this.sub_tasklist_obj.skills[this.subtaskIndexValue].tasks.length === 0) {
                  //this.sub_tasklist_obj.skills[this.subtaskIndexValue].addHeadingButtonShow = true;
                  //this.sub_tasklist_obj.skills[this.subtaskIndexValue].addTaskButtonShow = true;
                }
                setTimeout(() => {
                  var from_parent_sortid = this.sub_tasklist_obj.skills[this.subtaskIndexValue].sortid;
                  var j=1;
                  for(var i=0; i < this.sub_tasklist_obj.skills[this.subtaskIndexValue].tasks.length; i++) {
                    this.sub_tasklist_obj.skills[this.subtaskIndexValue].tasks[i].sortid = from_parent_sortid + '-task-' + j;
                    j++;
                  }
                  this.calculateTaskListsSummary();
                  this.$store.dispatch('subtasks', this.sub_tasklist_obj);
                }, 1000);
              }
              this.calculateTaskListsSummary();
              this.$store.dispatch('subtasks', this.sub_tasklist_obj);
            }
          },

          navigate(pathUrl) {
            router.go({
              path: pathUrl,
              force: true
            });
          },
          loadSubTaskListsAction: function(task_list_id) {
            this.$store.dispatch('subtasks', '');
            this.sub_tasklist_obj.sub_tasklists_lists = '';
            axios('/sub-tasklists/' + task_list_id,
              {
                method: 'GET',
              }
            )
            .then(resp => {
              this.loading = false;
              this.sub_tasklist_obj.skills = resp.data.skills;
              this.sub_tasklist_obj.tasks = resp.data.tasks;
              this.sub_tasklist_obj.tasklist = resp.data.tasklist;
              this.sub_tasklist_obj.subtaskupdate = resp.data.subtaskupdate;
              this.calculateTaskListsSummary();
              this.$store.dispatch('subtasks', this.sub_tasklist_obj);
            })
            .catch(error => {
              this.loading = false;
              if(error.response.data.message == 'Access denied.') {
                router.push("/forbidden");
              }
              else if(error.response.data.code == '404') {
                router.push("/view-tasklist");
              }
            })
          },
          fetchAffiliateOptions: function() {
            axios.get('/affiliateoptions', {

            })
            .then((response) => {
                var affiliate_option = {value: '', text: 'Select Affiliate'};
                this.affiliate_options.push(affiliate_option);
                for(var i=0; i < response.data.length; i++) {
                  var affiliate_option = {value: response.data[i].id, text: response.data[i].name};
                  this.affiliate_options.push(affiliate_option);
                }
            })
            .catch(error => {

            });

          },
          unload($event) {
            if (!this.changed()) return true;
          	var confirmationMessage = "\o/";
            $event.returnValue = confirmationMessage;     // Gecko, Trident, Chrome 34+
            return confirmationMessage;              // Gecko, WebKit, Chrome <34
          },
          changed() {
            if(this.sub_tasklist_obj.subtaskupdate == true) {
              this.content = "Editted";
            }
            else {
              this.content = "";
            }
            return this.content !== ''
          },
          scrollToElement(type) {
            const el = this.$el.getElementsByClassName('page_to_'+type)[0];
            if (el) {
              el.scrollIntoView({behavior: 'smooth'});
            }
          }
        },
        beforeRouteLeave(to, from, next) {
          if (this.changed() && !confirm('Changes that you made to the task list is not saved. Please save before leaving.'))
            next(false)
          else
            next()
        },
        beforeMount() {
        	window.addEventListener('beforeunload', this.unload)
        },
        beforeDestroy() {
        	window.removeEventListener('beforeunload', this.unload)
        },
        created: function () {
          this.loading = true;

          var roles = this.$store.state.roles;
          if(roles.indexOf('ROLE_MASTER_ADMIN') > -1) {
            this.masterAdmin = true;
          }
          if((roles.indexOf('ROLE_ADMIN') > -1) || (this.$store.state.switch_admin_username)) {
            this.admin = true;
          }
          if(roles.indexOf('ROLE_CSR') > -1) {
            this.csr = true;
          }
          if(this.$store.state.sub_tasks) {
            this.sub_tasklist_obj = this.$store.state.sub_tasks;
          }
          else {
            this.loadSubTaskListsAction(this.$route.params.task_list_id);
          }
          this.calculateTaskListsSummary();
          if((this.masterAdmin === true) && ((!this.$store.state.switch_admin_username) || (this.$store.state.switch_admin_username == ''))) {
           this.fetchAffiliateOptions();
          }
          if((this.$store.state.tasklist_title) && (this.$store.state.tasklist_title == 'Edit')) {
            this.pageHeading = 'Edit Skill Set';
          }
          else {
            this.pageHeading = 'New Skill Set';
          }
        }
}
</script>

<style scoped>

  .margin-top-10 {
    margin-top: 10px;
  }
  .margin-left-20 {
    margin-left: 0px;
  }
  ul .list-group-item {
    padding: 0;
  }
  .subtask_list li {
    background: none;
    border: 0px;
  }
  .subtask_list li .subtask_item, .subtaskadd {
    background: #FFF;
    padding: 5px 15px;
    margin-bottom: 5px;
  }
  .heading_container {
    padding-left: 30px;
  }
  .task_container {
    background: #FFF;
    line-height: 20px;
  }
  .task_container_padding {
    padding: 5px 15px 5px 30px;
  }
  .subtask_task_container {
    padding-left: 30px;
  }
  .subtask_task_container {
    background: #FFF;
    margin-left: 30px;
  }
  .subtask_task_container_padding {
    padding: 5px 15px;
  }
  .subtask_task_container_padding2 {
    padding: 1px 15px;
  }
  .heading_list li .heading_item, .headingadd {
    background: #D4D4D4;
    padding: 5px 15px 5px 15px;
    margin-bottom: 0px;
  }
  .save-button-width {
    width: 87px;
  }
  .task_item{
    line-height: 30px;
  }
  .margin-bottom-0 {
    margin-bottom: 0px !important;
  }
  .backgroud-none {
    background: none;
  }
  .createBtn {
    margin: 5px 0 3px 5px;
  }
  .form_row { width: 100%; display: flex; flex-wrap: wrap; padding: 0px; }
  .form_col_1 { width: 90%; margin-top: 10px; }
  .form_col_2 { width: 10%; margin-top: 5px; text-align: right; }
  .scroll_box {
    padding: 0;
    display: flex;
    justify-content: end;
  }
  .scroll_up_down {
    background-color: #efac91;
    padding: 5px;
    text-align: center;
    width: 40px;
  }
  .angle_font {
    color: #FFF !important;
    font-size: 1.8rem !important;
  }
  .input_class {
  line-height: 17px;
  border-radius: 10px;
  display: block;
  width: 100%;
  padding: 0.575rem 0.75rem 0.575rem 0.75rem;
  padding-left: 5px !important;
  border: 1px solid #707070;
  width: 100%;
  font-size: 1rem;
  font-weight: 400;
  }

</style>
<style>
#affliate-wrapper li span.multiselect__option--selected span::before {
  content: '\2713';
  color: #fff;
  background-color: #007bff;
  padding: 3px;
  margin-right: 5px;
}
#affliate-wrapper li span.multiselect__option--selected.multiselect__option--highlight {
  background-color: #fff !important;
  color: #212529 !important;
  font-weight: normal !important;
}
.multiselect__option--highlight {
  font-weight: normal !important;
  background-color: #fff !important;
  color: #212529 !important;
}
.multiselect__content-wrapper {
  min-width: 100%;
  width: auto !important;
  border-top: 1px solid #000 !important;
  border: 1px solid #000 !important;
}
.multiselect__option {
  font-size:13px;
}
.multiselect__option--selected {
  font-size: 13px;
  font-weight: normal !important;
}
.multiselect, .multiselect__input, .multiselect__single {
  font-size: 13px;
  font-weight: 400;
  color: #707070;
  background-color: inherit !important;
}
.default-hours-height {
  line-height: 17px;
  border-radius: 5px;
  padding-left: 5px !important;
  border: 1px solid #707070;

}
.readonly {
  background-color: rgba(239, 239, 239, 0.3);
}
.task-list-summary {
  font-size: 18px;
  font-weight: bold;
  padding-top: 5px;
}
.custom-checkbox .custom-control-input:disabled ~ .custom-control-label::before {
    background-color: #999999 !important;
    border: #999999;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>


// WEBPACK FOOTER //
// src/components/admin/create_sub_tasklists.vue